module.exports = __webpack_public_path__ + "static/team_cecilia-be7fac7f1a168628f6e9c1e5dc047c69.jpg";